"use strict";

var isObject = require("./is-object");

module.exports = function (value) {
	if (!isObject(value)) throw new TypeError(value + " is not an Object");
	return value;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/valid-object.js
// module id = 2674
// module chunks = 0